import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DialogData {
  titulo: string;
  mensaje: string;
  mensajeHTML: string;
}


@Component({
  selector: 'app-confirmar',
  templateUrl: 'confirmar.component.html'
})
export class ConfirmarComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<ConfirmarComponent>
    ) {
    }
}
